import { render, staticRenderFns } from "./orderFunctionTag.vue?vue&type=template&id=e16201e8&scoped=true&"
import script from "./orderFunctionTag.vue?vue&type=script&lang=js&"
export * from "./orderFunctionTag.vue?vue&type=script&lang=js&"
import style0 from "./orderFunctionTag.vue?vue&type=style&index=0&id=e16201e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16201e8",
  null
  
)

export default component.exports